var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camera",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(0 0.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31006",
    "data-name": "Path 31006",
    d: "M12.36,20.14H6.58C3.2,20.14,2,17.751,2,15.525V7.755C2,4.435,3.285,3.14,6.58,3.14h5.78c3.295,0,4.58,1.3,4.58,4.615v7.771C16.94,18.845,15.655,20.14,12.36,20.14ZM6.58,4.6c-2.485,0-3.133.652-3.133,3.156v7.771A2.853,2.853,0,0,0,6.58,18.682h5.78c2.485,0,3.133-.652,3.133-3.156V7.755c0-2.5-.648-3.156-3.133-3.156Z",
    transform: "translate(0 0)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31007",
    "data-name": "Path 31007",
    d: "M20.78,17.39a2.942,2.942,0,0,1-1.61-.546l-2.67-1.76a.7.7,0,0,1-.32-.583V8.779A.7.7,0,0,1,16.5,8.2l2.67-1.76a2.426,2.426,0,0,1,2.47-.358,2.145,2.145,0,0,1,1.11,2.108v6.9a2.134,2.134,0,0,1-1.11,2.108A1.835,1.835,0,0,1,20.78,17.39Zm-3.09-3.266,2.35,1.543c.45.292.77.32.9.254s.29-.329.29-.838V8.2c0-.518-.16-.772-.29-.838s-.45-.038-.9.254L17.69,9.155Z",
    transform: "translate(-0.75 0)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31008",
    "data-name": "Path 31008",
    d: "M11.5,11.75A2.25,2.25,0,1,1,13.75,9.5,2.253,2.253,0,0,1,11.5,11.75Zm0-3a.75.75,0,1,0,.75.75A.755.755,0,0,0,11.5,8.75Z",
    transform: "translate(-0.335 -0.224)",
    fill: "#2a7de1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8634",
    "data-name": "Rectangle 8634",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d37c9bda4d52bc9f7238e4e8152059b2.svg";
export { ForwardRef as ReactComponent };